export const ROW_CHECK_OPTIONS = {
  isCombiningValues: "isCombiningValues",
};

export const STAFF_FIELD_LINKS = {
  factNumber: "standardNumber",
  personTrained: "personRequiredTraining",
  personCertificated: "personRequiredCertificated",
  percentTrained: "percentRequiredTraining",
  percentCertificated: "percentRequiredCertificated",
};
